import ButtonGroup from "@/Common/Components/Buttons/ButtonGroup";
import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { Button } from "@/DesignSystem/Molecules/Button";
import AIScribeAction from "../Api/AIScribeAction";

import styles from "./AIScribe.module.scss";

interface IUnlinkCarewayProps {
    onClose: () => void;
    onUnlinkCarewayAccount: () => void;
}

function AIScribeUnlinkCarewayPopup(props: Readonly<IUnlinkCarewayProps>): JSX.Element {
    const { getText } = useTranslation();

    async function handleUnlinkCareWayAccount(): Promise<void> {
        const client = new AIScribeAction();
        const response = await client.unlinkUserAsync();
        if (response.IsSuccess) {
            props.onUnlinkCarewayAccount?.();
        }
    }

    function renderFooter(): JSX.Element {
        return (
            <div className="flex-container flex-end">
                <ButtonGroup>
                    <Button
                        category="secondary"
                        variant="neutral"
                        label={getText("CancelLabel")}
                        onClick={props.onClose}
                        dataCy="ai-scribe-unlink-careway-cancel"
                    />
                    <Button
                        category="secondary"
                        variant="error"
                        label={getText("AIScribe_Unlink")}
                        onClick={handleUnlinkCareWayAccount}
                        dataCy="ai-scribe-unlink-careway-unlink"
                    />
                </ButtonGroup>
            </div>
        );
    }

    return (
        <Modal
            fixedOverlayPosition
            showOverlay
            showX
            disableOverlayClose
            width={465}
            title={getText("AIScribe_UnlinkCarewayPopup_Title")}
            onClose={props.onClose}
            id="ai-scribe-unlink-careway-popup"
            dataCy="ai-scribe-unlink-careway-popup"
            footer={renderFooter()}
            cssClass={styles.unlinkPopup}
        >
            <div className={styles.body}>
                <p className={styles.question}>{getText("AIScribe_UnlinkCarewayPopup_Question")}</p>
                <p className={styles.firstSentence}>{getText("AIScribe_UnlinkCarewayPopup_FirstSentence")}</p>
                <p className={styles.secondSentence}>{getText("AIScribe_UnlinkCarewayPopup_SecondSentence")}</p>
            </div>
        </Modal>
    );
}

export { AIScribeUnlinkCarewayPopup };
